module.exports = __webpack_public_path__ + "static/img/4introduce.d84df783.jpg";